import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(ScrollTrigger, SplitText);


import CollectionProducts from '../snippets/collection-products';
import { onWidthResize, offWidthResize } from '../utils/resize.js';

export default class Designer {
  constructor(container) {
    this.container = container;
    this.title = this.container.querySelector('.designer__name');
    this.text_lines = new SplitText(this.title, { type: 'lines,words', linesClass: "lineParent" });
    this.hero_image = this.container.querySelector('.designer__hero-image');
    this.navLinks = container.querySelectorAll('.designer__nav-link');

    this.init();
    this.events();
  }

  init = () => {

    // Initialize the collection products snippet functionality
    const productsGrid = this.container.querySelector('.collection-products');
    if (productsGrid) {
      new CollectionProducts(this.container);
    }

    let tl = gsap.timeline({ delay: 0.2 });
    tl.fromTo(this.text_lines.words, { yPercent: 100, }, {
      yPercent: 0, duration: 1.6, stagger: { each: 0.3, ease: 'power.out', from: 'start' }, ease: 'power3.out',
      onComplete: () => onWidthResize(this.onResize)
    });
    if (this.hero_image) {
      tl.fromTo(this.hero_image, { clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)' }, { clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)', duration: 1.4, ease: 'power2.inOut' }, '<');
      tl.fromTo(this.hero_image.querySelector('img'), { scale: 1.4, }, { scale: 1, duration: 1.7, ease: 'power2.inOut' }, '<');
    }

  };

  events = () => {
    // Smooth scroll navigation for designer page
    this.navLinks.forEach((link) => {
      link.addEventListener('click', this.onClickNavLink);
    });
  };

  onClickNavLink = (e) => {
    const link = e.currentTarget;
    const href = link.getAttribute('href');

    if (href.startsWith('#')) {
      e.preventDefault();
      const target = document.querySelector(href);

      if (target) {
        // Update active state
        this.navLinks.forEach((l) => l.classList.remove('active'));
        link.classList.add('active');

        // Smooth scroll with offset for header
        const headerOffset = 100;
        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    }
  };

  onResize = () => {
    this.text_lines.revert();
    offWidthResize(this.onResize);
  }
}
